import { useNavigation } from '@react-navigation/core'
import React, { useCallback } from 'react'
import { AddBankAccountMethodBottomModal } from '../../../../../ui/add-payment-method-components'
import { FAB } from 'react-native-paper'
import AddPaymentMethodStore from '../../../../../store/AddPaymentMethodStore'
import { paths } from '../../../../links'
import { Tabs } from './ViewAddedMethods'

interface AddMethodFABProps {
  closePrevious?: (arg1: string) => void
  tab: string
  showModal?: (arg1: boolean) => void
}

export const AddMethodFAB: React.FC<AddMethodFABProps> = ({
  closePrevious,
  tab,
  showModal,
}) => {
  const navigation = useNavigation()
  const { setModal } = AddPaymentMethodStore

  const modalOnclose = useCallback(() => {
    setModal('')
    closePrevious && closePrevious('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setModal])

  return (
    <>
      <FAB
        style={{
          position: 'absolute',
          right: 10,
          bottom: 74,
          backgroundColor: '#00A0F3',
        }}
        /* eslint-disable i18next/no-literal-string */
        icon="plus"
        onPress={() => {
          closePrevious && closePrevious(tab)
          if (tab === Tabs.BANKS) {
            setModal('addBank')
          } else {
            navigation.navigate(paths.LinkCard, { showModal })
          }
        }}
      />
      <AddBankAccountMethodBottomModal onNavigate={modalOnclose} />
    </>
  )
}
